import type { ModuleKey } from '../../../../shell/session/store/sessionTypes';
import type { BranchPermission } from '../../../../shell/session/store/sessionTypes';
import type { NavZone } from '../../../../shell/navigation/navigationManifest';
import { NAV_ZONE_LABELS } from '../../../../shell/navigation/navigationManifest';
import { MODULE_LABELS_ES } from './permissionUiLabels';
import { matchesSearchAny } from '../../../../shared/format/searchText';

/** Zona de navegación por módulo de permisos (UI detalle empleado). */
export const MODULE_PERMISSION_ZONE: Record<ModuleKey, NavZone> = {
  POS: 'sell',
  Orders: 'sell',
  Tables: 'sell',
  Kitchen: 'sell',
  MenuOptions: 'inventory',
  Cash: 'control',
  Checks: 'control',
  Expenses: 'control',
  Purchases: 'inventory',
  Catalog: 'inventory',
  Inventory: 'inventory',
  Customers: 'control',
  Promotions: 'pricing',
  PriceLists: 'pricing',
  Loyalty: 'pricing',
  Reports: 'control',
  Agenda: 'control',
  WorkOrders: 'control',
  Commissions: 'control',
  Team: 'negocio',
  Organization: 'negocio',
  Billing: 'negocio',
  BranchSettings: 'negocio',
  Support: 'account',
};

export const PERMISSION_ZONE_ORDER: NavZone[] = [
  'sell',
  'control',
  'inventory',
  'pricing',
  'negocio',
  'account',
];

export type PermissionZoneGroup = {
  zone: NavZone;
  label: string;
  permissions: BranchPermission[];
};

export function groupPermissionsByZone(
  permissions: BranchPermission[],
  visibleModules: readonly ModuleKey[]
): PermissionZoneGroup[] {
  const visible = new Set(visibleModules);
  const byZone = new Map<NavZone, BranchPermission[]>();

  for (const perm of permissions) {
    if (!visible.has(perm.module)) continue;
    const zone = MODULE_PERMISSION_ZONE[perm.module] ?? 'negocio';
    const list = byZone.get(zone) ?? [];
    list.push(perm);
    byZone.set(zone, list);
  }

  return PERMISSION_ZONE_ORDER.filter((zone) => byZone.has(zone)).map((zone) => ({
    zone,
    label: NAV_ZONE_LABELS[zone],
    permissions: byZone.get(zone) ?? [],
  }));
}

export function filterPermissionsByModuleQuery(
  permissions: BranchPermission[],
  query: string
): BranchPermission[] {
  const q = query.trim().toLowerCase();
  if (!q) return permissions;
  return permissions.filter((perm) =>
    matchesSearchAny([MODULE_LABELS_ES[perm.module] ?? perm.module, perm.module], query),
  );
}
